import { render, staticRenderFns } from "./ActionsCatalogEditor.vue?vue&type=template&id=6b1aeec1&scoped=true&"
import script from "./ActionsCatalogEditor.vue?vue&type=script&lang=js&"
export * from "./ActionsCatalogEditor.vue?vue&type=script&lang=js&"
import style0 from "./ActionsCatalogEditor.vue?vue&type=style&index=0&id=6b1aeec1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1aeec1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCheckbox,VIcon,VTextField})
